{
	"title": "Carbon account settings",
	"adjust": "Adjust",
	"carbonOriginProportion": "Carbon origin proportion",
	"fossil": "Fossil",
	"biogenic": "Biogenic",
	"eacUom": "EAC UoM"
}
